import { useEffect, useMemo } from 'react';
import { useCreateMachine } from 'fsm';
import { machine } from './machine';
import { useCurrentUser } from 'policy-lib';
import { SmartPropertiesBatchContext } from './context';
import { usePanelAlerts } from '../../../Panel/usePanelAlerts';
import { FILL_EMPTY_ONLY_OPTION_VAL } from '../../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const SmartPropertiesBatchContextProvider = ({
  children,
  onClose,
  onEnrich,
  objectTypeId,
  selectionCrmSearchQuery,
  selectionIds,
  selectionMethod
}) => {
  const currentUser = useCurrentUser();
  const {
    onError,
    onSuccessProperties
  } = usePanelAlerts({
    objectTypeId: objectTypeId
  });
  const initialContext = {
    enrichmentType: 'company',
    fillOption: FILL_EMPTY_ONLY_OPTION_VAL,
    errorId: null,
    objectTypeId: objectTypeId,
    onClose,
    onError,
    onSuccess: onSuccessProperties,
    onEnrich,
    properties: [],
    selectedProperties: [],
    selectionCrmSearchQuery,
    selectionIds,
    selectionMethod,
    totalWithEmptyProperties: 0
  };
  const smartPropertiesMachine = useCreateMachine(machine, {
    initialContext,
    isReady: currentUser.isLoaded
  });
  const selectionState = useMemo(() => {
    return {
      selectionIds,
      selectionMethod,
      selectionCrmSearchQuery
    };
  }, [selectionIds, selectionMethod, selectionCrmSearchQuery]);
  useEffect(() => {
    if (smartPropertiesMachine.state.isRunning() && !smartPropertiesMachine.state.hasTag('loading')) {
      smartPropertiesMachine.send({
        type: 'SELECTION_CHANGE',
        data: selectionState
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionState]);
  return /*#__PURE__*/_jsx(SmartPropertiesBatchContext.Provider, {
    value: smartPropertiesMachine,
    children: children
  });
};